"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.array.sort");
require("core-js/modules/es6.regexp.search");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.number.constructor");
var _nodeIntervalTree = _interopRequireDefault(require("node-interval-tree"));
var _debounce = _interopRequireDefault(require("lodash/debounce"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var tagsToReplace = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;'
};
var _default = exports.default = {
  props: {
    maxHeight: {
      type: Number,
      required: false,
      default: 48
    },
    value: String,
    highlightStyle: {
      type: [String, Object],
      default: 'background-color:yellow'
    },
    placeholder: {
      type: String,
      required: false,
      default: '请输入'
    },
    highlightEnabled: {
      type: Boolean,
      default: true
    },
    spaceCharacterCheckFlag: {
      type: Boolean,
      default: true
    },
    highlightDelay: {
      type: Number,
      default: 500 // This is milliseconds
    },
    caseSensitive: {
      type: Boolean,
      default: false
    },
    fireOn: {
      type: String,
      default: 'keydown'
    },
    fireOnEnabled: {
      type: Boolean,
      default: true
    },
    isEditable: {
      type: Boolean,
      default: true
    },
    maxLength: {
      type: Number,
      required: false,
      default: 4000
    }
  },
  data: function data() {
    return {
      internalValue: '',
      htmlOutput: '',
      debouncedHandler: null,
      inputFlag: true // 是否在非翻译/非转换状态
    };
  },
  mounted: function mounted() {
    if (this.fireOnEnabled) this.$el.addEventListener(this.fireOn, this.handleChange);
    this.internalValue = this.value;
    this.processHighlights();
  },
  watch: {
    highlightStyle: function highlightStyle() {
      this.processHighlights();
    },
    value: function value() {
      if (this.internalValue != this.value) {
        this.internalValue = this.value;
        this.processHighlights();
      }
    },
    highlightEnabled: function highlightEnabled() {
      this.processHighlights();
    },
    caseSensitive: function caseSensitive() {
      this.processHighlights();
    },
    htmlOutput: function htmlOutput() {
      var selection = this.saveSelection(this.$el);
      this.$el.innerHTML = this.htmlOutput;
      this.restoreSelection(this.$el, selection);
    }
  },
  methods: {
    handleKeydown: function handleKeydown(event) {
      if (!this.isEditable) {
        event.preventDefault(); // Prevent typing if not editable
      }
      if (event.key === "Enter") {
        event.preventDefault(); // Prevent the default behavior
        document.execCommand('insertLineBreak');
      }
      if (this.$el.textContent.length >= this.maxLength && event.key !== "Backspace" && event.key !== "Delete" && !(event.ctrlKey && event.key === "a")) {
        event.preventDefault(); // Prevent input if maxLength is reached, but allow Ctrl+A
      }
    },
    handleChange: function handleChange() {
      this.debouncedHandler = (0, _debounce.default)(function () {
        if (this.internalValue !== this.$el.textContent) {
          this.internalValue = this.$el.textContent.substring(0, this.maxLength); // Ensure the internalValue does not exceed maxLength
          this.processHighlights();
        } else {
          var calculateByteLength = function calculateByteLength(str) {
            var blob = new Blob([str], {
              type: 'text/plain',
              charset: 'utf-8'
            });
            return blob.size;
          };
          var truncateInput = function truncateInput(value) {
            var truncatedValue = value;
            while (calculateByteLength(truncatedValue) > maxLength && truncatedValue.length > 0) {
              truncatedValue = truncatedValue.slice(0, -1);
            }
            return truncatedValue;
          };
          var maxLength = this.maxLength;
          this.internalValue = truncateInput(this.$el.textContent);
          this.processHighlights();
        }
      }, this.highlightDelay);
      this.debouncedHandler();
    },
    processHighlights: function processHighlights() {
      var _this = this;
      if (!this.highlightEnabled) {
        this.htmlOutput = this.internalValue;
        this.$emit('input', this.internalValue);
        return;
      }
      if (!this.inputFlag) {
        return;
      }
      var intervalTree = new _nodeIntervalTree.default();
      var highlightPositions = [];
      var sortedHighlights = this.normalizedHighlights();
      for (var i = 0; i < sortedHighlights.length; i++) {
        var highlightObj = sortedHighlights[i];
        if (this.spaceCharacterCheckFlag) {
          var text = this.internalValue;
          var textLength = text.length;
          var specialCharIndices = [];
          for (var _i = 0; _i < textLength; _i++) {
            var charCode = text.charCodeAt(_i);
            if (charCode === 160) {
              continue;
            }
            // 检查字符的合法性
            var isIllegalAscii = charCode < 32 && ![10, 13, 9].includes(charCode) || charCode > 126 || charCode === 124; // 排除 '|'

            if (isIllegalAscii) {
              specialCharIndices.push(_i);
            }
          }
          specialCharIndices.forEach(function (index) {
            _this.insertRange(index, index, highlightObj, intervalTree);
          });
        }
      }
      highlightPositions = intervalTree.search(0, this.internalValue.length);
      highlightPositions = highlightPositions.sort(function (a, b) {
        return a.start - b.start;
      });
      // Construct the output with styled spans around the highlight text
      var result = '';
      var startingPosition = 0;
      for (var k = 0; k < highlightPositions.length; k++) {
        var position = highlightPositions[k];
        result += this.safe_tags_replace(this.internalValue.substring(startingPosition, position.start));
        result += "<span style='" + highlightPositions[k].style + "'>" + this.safe_tags_replace(this.internalValue.substring(position.start, position.end + 1)) + "</span>";
        startingPosition = position.end + 1;
      }
      if (startingPosition < this.internalValue.length) result += this.safe_tags_replace(this.internalValue.substring(startingPosition, this.internalValue.length));
      this.htmlOutput = this.replaceSpacesInTextNodes(result);
      this.internalValue = this.internalValue.replace(/\u00A0/g, ' ');
      this.$emit('input', this.internalValue);
    },
    replaceSpacesInTextNodes: function replaceSpacesInTextNodes(html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      function traverse(node) {
        if (node.nodeType === Node.TEXT_NODE) {
          node.textContent = node.textContent.replace(/\u0020/g, "\xA0");
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          node.childNodes.forEach(function (child) {
            return traverse(child);
          });
        }
      }
      traverse(doc.body);
      return doc.body.innerHTML;
    },
    insertRange: function insertRange(start, end, highlightObj, intervalTree) {
      var overlap = intervalTree.search(start, end);
      var maxLengthOverlap = overlap.reduce(function (max, o) {
        return Math.max(o.end - o.start, max);
      }, 0);
      if (overlap.length === 0) {
        intervalTree.insert(start, end, {
          start: start,
          end: end,
          style: highlightObj.style
        });
      } else if (end - start > maxLengthOverlap) {
        overlap.forEach(function (o) {
          intervalTree.remove(o.start, o.end, o);
        });
        intervalTree.insert(start, end, {
          start: start,
          end: end,
          style: highlightObj.style
        });
      }
    },
    normalizedHighlights: function normalizedHighlights() {
      return [{
        text: '',
        style: 'background-color:#fca88f',
        caseSensitive: false
      }];
    },
    safe_tags_replace: function safe_tags_replace(str) {
      return str.replace(/[&<>]/g, this.replaceTag);
    },
    replaceTag: function replaceTag(tag) {
      return tagsToReplace[tag] || tag;
    },
    saveSelection: function saveSelection(containerEl) {
      var start;
      if (window.getSelection && document.createRange) {
        var selection = window.getSelection();
        if (!selection || selection.rangeCount == 0) return;
        var range = selection.getRangeAt(0);
        var preSelectionRange = range.cloneRange();
        preSelectionRange.selectNodeContents(containerEl);
        preSelectionRange.setEnd(range.startContainer, range.startOffset);
        start = preSelectionRange.toString().length;
        return {
          start: start,
          end: start + range.toString().length
        };
      } else if (document.selection) {
        var selectedTextRange = document.selection.createRange();
        var preSelectionTextRange = document.body.createTextRange();
        preSelectionTextRange.moveToElementText(containerEl);
        preSelectionTextRange.setEndPoint("EndToStart", selectedTextRange);
        start = preSelectionTextRange.text.length;
        return {
          start: start,
          end: start + selectedTextRange.text.length
        };
      }
    },
    divCompositionstart: function divCompositionstart() {
      // 翻译开始
      this.inputFlag = false;
    },
    divCompositionend: function divCompositionend() {
      // 翻译结束
      this.inputFlag = true;
      // 翻译结束后执行一次赋值和高亮程序
      if (this.$el.textContent.length <= this.maxLength) {
        // Check if the text content length is within maxLength
        this.internalValue = this.$el.textContent;
        this.processHighlights();
      } else {
        this.internalValue = this.$el.textContent.substring(0, this.maxLength); // Truncate the text content to maxLength
        this.processHighlights();
      }
    },
    restoreSelection: function restoreSelection(containerEl, savedSel) {
      if (!savedSel) return;
      if (window.getSelection && document.createRange) {
        var charIndex = 0,
          range = document.createRange();
        range.setStart(containerEl, 0);
        range.collapse(true);
        var nodeStack = [containerEl],
          node,
          foundStart = false,
          stop = false;
        while (!stop && (node = nodeStack.pop())) {
          if (node.nodeType == 3) {
            var nextCharIndex = charIndex + node.length;
            if (!foundStart && savedSel.start >= charIndex && savedSel.start <= nextCharIndex) {
              range.setStart(node, savedSel.start - charIndex);
              foundStart = true;
            }
            if (foundStart && savedSel.end >= charIndex && savedSel.end <= nextCharIndex) {
              range.setEnd(node, savedSel.end - charIndex);
              stop = true;
            }
            charIndex = nextCharIndex;
          } else {
            var i = node.childNodes.length;
            while (i--) {
              nodeStack.push(node.childNodes[i]);
            }
          }
        }
        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
      } else if (document.selection) {
        var textRange = document.body.createTextRange();
        textRange.moveToElementText(containerEl);
        textRange.collapse(true);
        textRange.moveEnd("character", savedSel.end);
        textRange.moveStart("character", savedSel.start);
        textRange.select();
      }
    },
    cusFocus: function cusFocus() {
      this.$emit('focus');
    },
    handleBlur: function handleBlur(event) {
      // 获取编辑框的文本内容
      var textContent = this.$el.textContent;

      // 将文本内容转换为大写，并去除每行文本前后的空格
      textContent = textContent.toUpperCase().split('\n').map(function (line) {
        return line.trim();
      }).join('\n');

      // 更新 internalValue 和 htmlOutput
      this.internalValue = textContent;
      this.htmlOutput = this.formatedInTextNodes(textContent);

      // 重新处理高亮
      this.processHighlights();
    },
    formatedInTextNodes: function formatedInTextNodes(html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      function traverse(node) {
        if (node.nodeType === Node.TEXT_NODE) {
          node.textContent = node.textContent.toUpperCase().trim().replace(/[ \t]*(\n|\r\n)[ \t]*/g, '$1').replace(/\u0020/g, "\xA0");
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          node.childNodes.forEach(function (child) {
            return traverse(child);
          });
        }
      }
      traverse(doc.body);
      return doc.body.innerHTML;
    },
    handlePaste: function handlePaste(event) {
      event.preventDefault(); // 阻止默认的黏贴行为

      // 获取黏贴的文本内容
      var pastedText = (event.clipboardData || window.clipboardData).getData('text/plain');

      // 检查当前文本内容的长度
      var currentLength = this.$el.textContent.length;

      // 计算可以黏贴的最大长度
      var maxLengthToPaste = this.maxLength - currentLength;

      // 截断黏贴的文本内容
      var textToInsert = pastedText.substring(0, maxLengthToPaste);

      // 插入截断后的文本内容
      var selection = window.getSelection();
      if (!selection.rangeCount) return false;
      var range = selection.getRangeAt(0);
      range.deleteContents();
      var textNode = document.createTextNode(textToInsert);
      range.insertNode(textNode);
      range.setStartAfter(textNode);
      range.setEndAfter(textNode);
      selection.removeAllRanges();
      selection.addRange(range);

      // 更新 internalValue
      this.internalValue = this.$el.textContent;
      this.processHighlights();
    }
  }
};